import React from "react";

import styles from "./Loading.module.scss";

const LETTERS = [
  { ch: "R", x: 18, delay: "0s" },
  { ch: "O", x: 72, delay: "0.2s" },
  { ch: "V", x: 128, delay: "0.4s" },
  { ch: "I", x: 178, delay: "0.6s" },
  { ch: "O", x: 228, delay: "0.8s" },
  { ch: "N", x: 282, delay: "1s" },
];

export default function Loading() {
  return (
    <div className={styles["loading-container"]}>
      <svg
        width="420"
        height="100"
        viewBox="0 0 360 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {LETTERS.map(({ ch, x, delay }) => (
          <text
            key={`${ch}-${x}`}
            x={x}
            y="50"
            className={styles["loading-container__letter"]}
            style={{ animationDelay: delay }}
          >
            {ch}
          </text>
        ))}
      </svg>
    </div>
  );
}
